import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import React from 'react';
import './Kavan.css';


function Kavan() {

    const docs = [
        {
            uri: require("../../../../../Icon/KavanRelocating_CaseStudy_V2.pdf"),
            fileType: 'pdf',
            fileName: 'Kavan Relocating.pdf'

        },
    ];
    return (
        <div className='kavan-section'>
            <div className='kavan-head'></div>
            <div>
                <DocViewer documents={docs} initialActiveDocument={docs[1]} pluginRenderers={DocViewerRenderers} />
            </div>
        </div>
    );
}

export default Kavan;